<template>
    <div class="ts-finder__checkbox" :class="checkboxTypeClass" ref="component">
        <input type="checkbox" @change="applyFilter" :checked="isChecked" :disabled="amountOnApply == 0" :id="checkboxId" :class="{ 'semi-checked' : isSemiChecked }" />
        <label :for="checkboxId">{{filter.name}} <span class="ts-finder__filterpanel-filter-count">({{amountOnApply}})</span></label>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'
    import * as R from 'ramda'
    import * as FilterHelper from '../../../utils/stationfilter'

    export default {
        props: ['filter', 'level'],
        computed: {
            ...mapState([
                'selectedCapabilityFilters',
                'filteredStationsForORCapabilityCount',
                'filteredStationsForANDCapabilityCount'
            ]),
            amountOnApply() {
                if (this.filter.group[0] == 'a') {
                    return R.filter((station) => station.capabilities.includes(this.filter.filter), this.filteredStationsForANDCapabilityCount).length;
                } else {
                    return R.filter((station) => station.capabilities.includes(this.filter.filter), this.filteredStationsForORCapabilityCount).length;
                }
            },
            isChecked() {
                return FilterHelper.isCapabilityFilterActive(this.selectedCapabilityFilters, this.filter);
            },
            checkboxId() {
                return 'ts-finder_cb_' + this.filter.filter;
            },
            checkboxTypeClass() {
                if (this.level == 2 && this.filter.group[0] == 'a') {
                    //if we are at level 2 and group starts with 'a' (AND-Filter), render a switch
                    return 'ts-finder__checkbox--switch';
                } else {
                    return 'ts-finder__checkbox--checkbox';
                }
            },
            isSemiChecked() {
                if (this.level != 1)
                    return false;
                if (!this.filter.children)
                    return false;

                var andFilters = this.selectedCapabilityFilters["a_" + this.filter.filter];
                var orFilters = this.selectedCapabilityFilters["o_" + this.filter.filter];

                return (andFilters !== undefined && andFilters.length > 0 && andFilters.length != this.filter.children.length)
                    || (orFilters !== undefined && orFilters.length > 0 && orFilters.length != this.filter.children.length);

            }
        },
        methods: {
            ...mapActions([
                'addCapabilityFilter',
                'removeCapabilityFilter'
            ]),
            applyFilter(event) {
                if (event.target.checked) {
                    this.$emit('changed', { target: this.$refs.component, checked: true });
                    this.addCapabilityFilter({ filter: this.filter });
                } else {
                    this.$emit('changed', { target: this.$refs.component, checked: false });
                    this.removeCapabilityFilter({ filter: this.filter });
                }
            }
        }
    };
</script>